
/**
 * Comprehensive data for TED Notice Subtypes
 */

export interface NoticeSubtype {
  id: string;
  legalBasis: string;
  formType: string;
  noticeType: string;
  documentTypeId: string;
  description: string;
}

export const NOTICE_SUBTYPES: NoticeSubtype[] = [
  {
    id: "1",
    legalBasis: "32014L0024",
    formType: "planning",
    noticeType: "pin-buyer",
    documentTypeId: "PIN",
    description: "Notice of the publication of a prior information notice on a buyer profile - general directive"
  },
  {
    id: "2",
    legalBasis: "32014L0025",
    formType: "planning",
    noticeType: "pin-buyer",
    documentTypeId: "PIN",
    description: "Notice of the publication of a periodic indicative notice on a buyer profile - sectoral directive"
  },
  {
    id: "3",
    legalBasis: "32009L0081",
    formType: "planning",
    noticeType: "pin-buyer",
    documentTypeId: "PIN",
    description: "Notice of the publication of a prior information notice on a buyer profile - defence directive"
  },
  {
    id: "4",
    legalBasis: "32014L0024",
    formType: "planning",
    noticeType: "pin-only",
    documentTypeId: "PIN",
    description: "Prior information notice used only for information – general directive"
  },
  {
    id: "5",
    legalBasis: "32014L0025",
    formType: "planning",
    noticeType: "pin-only",
    documentTypeId: "PIN",
    description: "Periodic indicative notice used only for information – sectoral directive"
  },
  {
    id: "6",
    legalBasis: "32009L0081",
    formType: "planning",
    noticeType: "pin-only",
    documentTypeId: "PIN",
    description: "Prior information notice used only for information – defence directive"
  },
  {
    id: "7",
    legalBasis: "32014L0024",
    formType: "planning",
    noticeType: "pin-rtl",
    documentTypeId: "PIN",
    description: "Prior information notice used to shorten time limits for receipt of tenders – general directive"
  },
  {
    id: "8",
    legalBasis: "32014L0025",
    formType: "planning",
    noticeType: "pin-rtl",
    documentTypeId: "PIN",
    description: "Periodic indicative notice used to shorten time limits for receipt of tenders – sectoral directive"
  },
  {
    id: "9",
    legalBasis: "32009L0081",
    formType: "planning",
    noticeType: "pin-rtl",
    documentTypeId: "PIN",
    description: "Prior information notice used to shorten time limits for receipt of tenders – defence directive"
  },
  {
    id: "10",
    legalBasis: "32014L0024",
    formType: "competition",
    noticeType: "pin-cfc-standard",
    documentTypeId: "PIN",
    description: "Prior information notice used as a call for competition - general directive, standard regime"
  },
  {
    id: "11",
    legalBasis: "32014L0025",
    formType: "competition",
    noticeType: "pin-cfc-standard",
    documentTypeId: "PIN",
    description: "Periodic indicative notice used as a call for competition - sectoral directive, standard regime"
  },
  {
    id: "12",
    legalBasis: "32014L0024",
    formType: "competition",
    noticeType: "pin-cfc-social",
    documentTypeId: "PIN",
    description: "Prior information notice used as a call for competition - general directive, light regime"
  },
  {
    id: "13",
    legalBasis: "32014L0025",
    formType: "competition",
    noticeType: "pin-cfc-social",
    documentTypeId: "PIN",
    description: "Periodic indicative notice used as a call for competition - sectoral directive, light regime"
  },
  {
    id: "14",
    legalBasis: "32014L0023",
    formType: "competition",
    noticeType: "pin-cfc-social",
    documentTypeId: "PIN",
    description: "Prior information notice used as a call for competition - concessions directive, light regime"
  },
  {
    id: "15",
    legalBasis: "32014L0025",
    formType: "competition",
    noticeType: "qu-sy",
    documentTypeId: "CN",
    description: "Notice on the existence of a qualification system – sectoral directive"
  },
  {
    id: "16",
    legalBasis: "32014L0024",
    formType: "competition",
    noticeType: "cn-standard",
    documentTypeId: "CN",
    description: "Contract notice – general directive, standard regime"
  },
  {
    id: "17",
    legalBasis: "32014L0025",
    formType: "competition",
    noticeType: "cn-standard",
    documentTypeId: "CN",
    description: "Contract notice – sectoral directive, standard regime"
  },
  {
    id: "18",
    legalBasis: "32009L0081",
    formType: "competition",
    noticeType: "cn-standard",
    documentTypeId: "CN",
    description: "Contract notice – defence directive, standard regime"
  },
  {
    id: "19",
    legalBasis: "32014L0023",
    formType: "competition",
    noticeType: "cn-standard",
    documentTypeId: "CN",
    description: "Concession notice – concessions directive, standard regime"
  },
  {
    id: "20",
    legalBasis: "32014L0024",
    formType: "competition",
    noticeType: "cn-social",
    documentTypeId: "CN",
    description: "Contract notice – general directive, light regime"
  },
  {
    id: "21",
    legalBasis: "32014L0025",
    formType: "competition",
    noticeType: "cn-social",
    documentTypeId: "CN",
    description: "Contract notice – sectoral directive, light regime"
  },
  {
    id: "22",
    legalBasis: "32009L0081",
    formType: "competition",
    noticeType: "subco",
    documentTypeId: "CN",
    description: "Subcontract notice – defence directive"
  },
  {
    id: "23",
    legalBasis: "32014L0024",
    formType: "competition",
    noticeType: "cn-desg",
    documentTypeId: "CN",
    description: "Design contest notice – general directive, design"
  },
  {
    id: "24",
    legalBasis: "32014L0025",
    formType: "competition",
    noticeType: "cn-desg",
    documentTypeId: "CN",
    description: "Design contest notice – sectoral directive, design"
  },
  {
    id: "25",
    legalBasis: "32014L0024",
    formType: "dir-awa-pre",
    noticeType: "veat",
    documentTypeId: "CAN",
    description: "Voluntary ex-ante transparency notice – general directive"
  },
  {
    id: "26",
    legalBasis: "32014L0025",
    formType: "dir-awa-pre",
    noticeType: "veat",
    documentTypeId: "CAN",
    description: "Voluntary ex-ante transparency notice – sectoral directive"
  },
  {
    id: "27",
    legalBasis: "32009L0081",
    formType: "dir-awa-pre",
    noticeType: "veat",
    documentTypeId: "CAN",
    description: "Voluntary ex-ante transparency notice – defence directive"
  },
  {
    id: "28",
    legalBasis: "32014L0023",
    formType: "dir-awa-pre",
    noticeType: "veat",
    documentTypeId: "CAN",
    description: "Voluntary ex-ante transparency notice – concession directive"
  },
  {
    id: "29",
    legalBasis: "32014L0024",
    formType: "result",
    noticeType: "can-standard",
    documentTypeId: "CAN",
    description: "Contract award notice – general directive, standard regime"
  },
  {
    id: "30",
    legalBasis: "32014L0025",
    formType: "result",
    noticeType: "can-standard",
    documentTypeId: "CAN",
    description: "Contract award notice – sectoral directive, standard regime"
  },
  {
    id: "31",
    legalBasis: "32009L0081",
    formType: "result",
    noticeType: "can-standard",
    documentTypeId: "CAN",
    description: "Contract award notice – defence directive, standard regime"
  },
  {
    id: "32",
    legalBasis: "32014L0023",
    formType: "result",
    noticeType: "can-standard",
    documentTypeId: "CAN",
    description: "Concession award notice – concession directive, standard regime"
  },
  {
    id: "33",
    legalBasis: "32014L0024",
    formType: "result",
    noticeType: "can-social",
    documentTypeId: "CAN",
    description: "Contract award notice – general directive, light regime"
  },
  {
    id: "34",
    legalBasis: "32014L0025",
    formType: "result",
    noticeType: "can-social",
    documentTypeId: "CAN",
    description: "Contract award notice – sectoral directive, light regime"
  },
  {
    id: "35",
    legalBasis: "32014L0023",
    formType: "result",
    noticeType: "can-social",
    documentTypeId: "CAN",
    description: "Concession award notice – concessions directive, light regime"
  },
  {
    id: "36",
    legalBasis: "32014L0024",
    formType: "result",
    noticeType: "can-desg",
    documentTypeId: "CAN",
    description: "Design contest result notice – general directive, design"
  },
  {
    id: "37",
    legalBasis: "32014L0025",
    formType: "result",
    noticeType: "can-desg",
    documentTypeId: "CAN",
    description: "Design contest result notice – sectoral directive, design"
  },
  {
    id: "38",
    legalBasis: "32014L0024",
    formType: "cont-modif",
    noticeType: "can-modif",
    documentTypeId: "CAN",
    description: "Contract modification notice – general directive"
  },
  {
    id: "39",
    legalBasis: "32014L0025",
    formType: "cont-modif",
    noticeType: "can-modif",
    documentTypeId: "CAN",
    description: "Contract modification notice – sectoral directive"
  },
  {
    id: "40",
    legalBasis: "32014L0023",
    formType: "cont-modif",
    noticeType: "can-modif",
    documentTypeId: "CAN",
    description: "Contract modification notice – concessions directive"
  },
  {
    id: "E1",
    legalBasis: "unknown",
    formType: "planning",
    noticeType: "unknown",
    documentTypeId: "PIN",
    description: "Preliminary market consultation notice"
  },
  {
    id: "E2",
    legalBasis: "other",
    formType: "planning",
    noticeType: "pin-only",
    documentTypeId: "PIN",
    description: "Below Threshold Prior Information Notice (PIN) Only"
  },
  {
    id: "E3",
    legalBasis: "other",
    formType: "competition",
    noticeType: "cn-standard",
    documentTypeId: "CN",
    description: "Below Threshold Contract Notice (CN) general"
  },
  {
    id: "E4",
    legalBasis: "other",
    formType: "result",
    noticeType: "can-standard",
    documentTypeId: "CAN",
    description: "Below Threshold Contract Award Notice (CAN) general"
  },
  {
    id: "E5",
    legalBasis: "unknown",
    formType: "completion",
    noticeType: "unknown",
    documentTypeId: "CAN",
    description: "Contract Completion Notice"
  },
  {
    id: "CEI",
    legalBasis: "32018R1046",
    formType: "competition",
    noticeType: "pin-cfc-standard",
    documentTypeId: "PIN",
    description: "Call for expressions of interest"
  },
  {
    id: "T01",
    legalBasis: "32007R1370",
    formType: "planning",
    noticeType: "pin-tran",
    documentTypeId: "PIN",
    description: "Planning notice for public passenger transport services by rail and by road"
  },
  {
    id: "T02",
    legalBasis: "32007R1370",
    formType: "result",
    noticeType: "can-tran",
    documentTypeId: "CAN",
    description: "Result notice for public passenger transport services by rail and by road"
  },
  {
    id: "X01",
    legalBasis: "31985R2137",
    formType: "bri",
    noticeType: "brin-eeig",
    documentTypeId: "BRIN",
    description: "Notice containing information relevant to Formation or Completion of the liquidation of a EEIG."
  },
  {
    id: "X02",
    legalBasis: "32001R2157",
    formType: "bri",
    noticeType: "brin-ecs",
    documentTypeId: "BRIN",
    description: "Notice containing information about Registration, Deletion, Transfer-registration or Transfer-deletion of a European Company or European Cooperative Society"
  }
];

/**
 * Get a notice subtype by its ID
 */
export function getNoticeSubtypeById(id: string | undefined | null): NoticeSubtype | null {
  if (!id) return null;
  return NOTICE_SUBTYPES.find(subtype => subtype.id === id) || null;
}

/**
 * Get a notice subtype by its notice type
 */
export function getNoticeSubtypeByNoticeType(noticeType: string | undefined | null): NoticeSubtype | null {
  if (!noticeType) return null;
  return NOTICE_SUBTYPES.find(subtype => subtype.noticeType === noticeType) || null;
}

/**
 * Get a list of notice subtypes for a specific notice type
 */
export function getNoticeSubtypesByNoticeType(noticeType: string | undefined | null): NoticeSubtype[] {
  if (!noticeType) return [];
  return NOTICE_SUBTYPES.filter(subtype => subtype.noticeType === noticeType);
}

/**
 * Get legal basis description from code
 */
export function getLegalBasisDescription(code: string): string {
  const legalBasisMap: Record<string, string> = {
    "32014L0024": "Directive 2014/24/EU (General Public Procurement)",
    "32014L0025": "Directive 2014/25/EU (Utilities)",
    "32014L0023": "Directive 2014/23/EU (Concessions)",
    "32009L0081": "Directive 2009/81/EC (Defence)",
    "32007R1370": "Regulation 1370/2007 (Public Passenger Transport)",
    "31985R2137": "Regulation 2137/85 (EEIG)",
    "32001R2157": "Regulation 2157/2001 (European Company)",
    "32018R1046": "Regulation 2018/1046 (Financial)",
    "other": "Other legal basis",
    "unknown": "Unknown legal basis"
  };

  return legalBasisMap[code] || code;
}

/**
 * Get form type description
 */
export function getFormTypeDescription(formType: string): string {
  const formTypeMap: Record<string, string> = {
    "planning": "Planning",
    "competition": "Competition",
    "result": "Result",
    "cont-modif": "Contract Modification",
    "dir-awa-pre": "Direct Award Pre-notification",
    "completion": "Contract Completion",
    "bri": "Business Register Information"
  };

  return formTypeMap[formType] || formType;
}

/**
 * Get document type description
 */
export function getDocumentTypeDescription(documentType: string): string {
  const documentTypeMap: Record<string, string> = {
    "PIN": "Prior Information Notice",
    "CN": "Contract Notice",
    "CAN": "Contract Award Notice",
    "BRIN": "Business Register Information Notice"
  };

  return documentTypeMap[documentType] || documentType;
}
